const INVALID_TENANT_ID_VALUES = new Set([
  'undefined',
  'null',
  'nan',
  '[object object]',
])

export function normalizeTenantId(value) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value)
  }

  if (typeof value !== 'string') return null

  const trimmed = value.trim()
  if (!trimmed) return null
  if (INVALID_TENANT_ID_VALUES.has(trimmed.toLowerCase())) return null

  return trimmed
}

export function getReadyBranchTenantId(tenantId, branches, branchBootstrapStatus) {
  const normalizedTenantId = normalizeTenantId(tenantId)
  if (!normalizedTenantId || branchBootstrapStatus !== 'ready') return null

  const hasMatchingBranch = Array.isArray(branches) && branches.some((branch) => {
    const branchTenantId = normalizeTenantId(branch?.tenant_id)
    return branchTenantId === normalizedTenantId
  })

  return hasMatchingBranch ? normalizedTenantId : null
}
